<template>
    <form class="form-horizontal pl-2">
        <div class="form-group row">
            <label for="firstname" class="col-sm-4 col-form-label"
                >First Name:</label
            >
            <div class="col">
                <vue-simple-suggest
                    ref="suggestField"
                    :min-length="3"
                    :max-suggestions="0"
                    v-model="chosenClient"
                    display-attribute="firstname"
                    value-attribute="id"
                    :list="searchClient"
                    :styles="{ suggestItem: 'suggest-item-vetter' }"
                    :debounce="300"
                    @select="selectSuggestedRecord"
                >
                    <input
                        placeholder="First Name (required)"
                        name="firstname"
                        v-model="data.firstname"
                        :class="{ 'border-danger': errors.has('firstname') }"
                        v-validate="'required'"
                        class="form-control"
                        type="text"
                    />
                    <div slot="suggestion-item" slot-scope="{ suggestion }">
                        <div>
                            <span style="display: block;">
                                <b>{{ suggestion.fullName }}</b>
                            </span>
                            <span
                                v-if="suggestion.email"
                                style="display: block;"
                            >
                                E: {{ suggestion.email }}
                            </span>
                            <span
                                v-if="suggestion.mobile"
                                style="display: block;"
                            >
                                M: {{ suggestion.mobile }}
                            </span>
                            <span
                                v-if="!suggestion.mobile && suggestion.home"
                                style="display: block;"
                            >
                                H: {{ suggestion.home }}
                            </span>
                        </div>
                    </div>
                </vue-simple-suggest>
            </div>
        </div>
        <div class="form-group row">
            <label for="lastname" class="col-sm-4 col-form-label"
                >Last Name:</label
            >
            <div class="col">
                <input
                    id="lastname"
                    v-model="data.lastname"
                    :class="{ 'border-danger': errors.has('lastname') }"
                    v-validate="'required'"
                    name="lastname"
                    class="form-control"
                    type="text"
                    placeholder="Last Name (required)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="address" class="col-sm-4 col-form-label"
                >Address:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="address"
                    v-model="data.address"
                    module="address"
                    class="form-control"
                    placeholder="Address (optional)"
                    name="address"
                />
            </div>
            <div v-else class="col">
                <v-address-picker-aws
                    id="address"
                    v-model="data.address"
                    module="address"
                    placeholder="Address (optional)"
                    name="address"
                    @address-picked="addressPicked"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="zipcode" class="col-sm-4 col-form-label"
                >Zipcode:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="zipcode"
                    v-model="data.zipcode"
                    module="zipcode"
                    name="zipcode"
                    class="form-control"
                    placeholder="Zipcode (optional)"
                />
            </div>
            <div v-else class="col">
                <b-form-input
                    id="zipcode"
                    v-model="data.zipcode"
                    module="zipcode"
                    name="zipcode"
                    placeholder="Zipcode (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="city" class="col-sm-4 col-form-label">City:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="city"
                    v-model="data.city"
                    module="city"
                    class="form-control"
                    placeholder="City (optional)"
                />
            </div>
            <div v-else class="col">
                <b-form-input
                    id="city"
                    v-model="data.city"
                    module="city"
                    placeholder="City (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="state" class="col-sm-4 col-form-label">State:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="state"
                    v-model="data.state"
                    module="state"
                    name="state"
                    class="form-control"
                    placeholder="State (optional)"
                />
            </div>
            <div v-else class="col">
                <b-form-input
                    id="state"
                    v-model="data.state"
                    module="state"
                    name="state"
                    placeholder="State (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="country" class="col-sm-4 col-form-label"
                >Country:</label
            >
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="country"
                    v-model="data.country"
                    module="country"
                    name="country"
                    class="form-control"
                    placeholder="Country (optional)"
                />
            </div>
            <div v-else class="col">
                <b-form-input
                    id="country"
                    v-model="data.country"
                    module="country"
                    name="country"
                    placeholder="Country (optional)"
                />
            </div>
        </div>
        <div class="form-group row" style="display: none;">
            <label for="county" class="col-sm-4 col-form-label">County:</label>
            <div v-if="use_google_location" class="col">
                <v-address-picker
                    id="county"
                    v-model="data.county"
                    module="county"
                    name="county"
                    class="form-control"
                    placeholder="county (optional)"
                />
            </div>
            <div v-else class="col">
                <b-form-input
                    id="county"
                    v-model="data.county"
                    module="county"
                    name="county"
                    placeholder="county (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="birthdate" class="col-sm-4 col-form-label"
                >Birthdate:</label
            >
            <div class="col">
                <date-picker
                    :config="datePickerOptions"
                    v-model="formattedBirthdate"
                    @dp-show="_datePickerShow"
                    v-validate="''"
                    :class="{ 'border-danger': errors.has('birthdate') }"
                    :placeholder="getDateFormat()"
                    name="birthdate"
                ></date-picker>
            </div>
        </div>
        <div class="form-group row">
            <label for="email" class="col-sm-4 col-form-label">Email:</label>
            <div class="col">
                <input
                    id="email"
                    v-model="data.email"
                    :class="{ 'border-danger': errors.has('email') }"
                    v-validate="'email'"
                    class="form-control"
                    name="email"
                    :placeholder="emailPlaceholder"
                />

                <contact-warning
                    :type="CLIENT.CONTACT_DETAIL_TYPES.EMAIL"
                    :value="data.email"
                    :contacts="contacts"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="driver_license" class="col-sm-4 col-form-label"
                >Driver License:</label
            >
            <div class="col">
                <input
                    id="driver_license"
                    v-model="data.driver_license"
                    class="form-control"
                    name="driver_license"
                    placeholder="Driver License (optional)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label for="home" class="col-sm-4 col-form-label">Home:</label>
            <div class="col">
                <div class="row">
                    <div class="col-3 col-sm-5">
                        <CountryCode
                            v-model="data.home_country_code"
                            :defaultValue="$root.setting.phone_code"
                            class="form-control"
                        />
                    </div>
                    <div class="col pl-0">
                        <input
                            id="home"
                            v-model="data.home"
                            v-validate="'international_phone'"
                            :class="{ 'border-danger': errors.has('home') }"
                            name="home"
                            type="text"
                            class="form-control"
                            placeholder="Home Phone (optional)"
                        />
                    </div>

                    <contact-warning
                        class="col-sm-12"
                        :type="CLIENT.CONTACT_DETAIL_TYPES.HOME"
                        :value="data.home"
                        :contacts="contacts"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="mobile" class="col-sm-4 col-form-label">Mobile:</label>
            <div class="col">
                <div class="row">
                    <div class="col-3 col-sm-5">
                        <CountryCode
                            ref="mobile_country_code"
                            v-model="data.mobile_country_code"
                            :defaultValue="$root.setting.phone_code"
                            class="form-control"
                        />
                    </div>
                    <div class="col pl-0">
                        <input
                            id="mobile"
                            v-model="data.mobile"
                            v-validate="'international_phone'"
                            :class="{ 'border-danger': errors.has('mobile') }"
                            data-vv-delay="800"
                            name="mobile"
                            type="text"
                            class="form-control"
                            :placeholder="mobilePhonePlaceholder"
                        />
                    </div>
                    <contact-warning
                        class="col-sm-12"
                        :type="CLIENT.CONTACT_DETAIL_TYPES.MOBILE"
                        :value="data.mobile"
                        :contacts="contacts"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="work" class="col-sm-4 col-form-label">Work:</label>
            <div class="col">
                <div class="row">
                    <div class="col-3 col-sm-5">
                        <CountryCode
                            v-model="data.work_country_code"
                            :defaultValue="$root.setting.phone_code"
                            class="form-control"
                        />
                    </div>
                    <div class="col pl-0">
                        <input
                            id="work"
                            v-model="data.work"
                            v-validate="'international_phone'"
                            :class="{ 'border-danger': errors.has('work') }"
                            name="work"
                            type="text"
                            class="form-control"
                            placeholder="Work Phone (optional)"
                        />
                    </div>
                    <contact-warning
                        class="col-sm-12"
                        :type="CLIENT.CONTACT_DETAIL_TYPES.WORK"
                        :value="data.work"
                        :contacts="contacts"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="fax" class="col-sm-4 col-form-label">Fax:</label>
            <div class="col">
                <div class="row">
                    <div class="col-3 col-sm-5">
                        <CountryCode
                            v-model="data.fax_country_code"
                            :defaultValue="$root.setting.phone_code"
                            class="form-control"
                        />
                    </div>
                    <div class="col pl-0">
                        <input
                            id="fax"
                            v-model="data.fax"
                            v-validate="'international_phone'"
                            :class="{ 'border-danger': errors.has('fax') }"
                            name="fax"
                            type="text"
                            class="form-control"
                            placeholder="Fax (optional)"
                        />
                    </div>
                    <contact-warning
                        class="col-sm-12"
                        :type="CLIENT.CONTACT_DETAIL_TYPES.FAX"
                        :value="data.fax"
                        :contacts="contacts"
                    />
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="reminder" class="col-sm-4 col-form-label"
                >Reminders:</label
            >
            <div class="col">
                <v-select
                    id="reminder"
                    :options="reminder_options_filter"
                    v-model="reminder_options_output"
                    placeholder="Reminder Option (optional)"
                    multiple
                />
            </div>
        </div>
    </form>
</template>
<script>
import vAddressPicker from "@/module/commons/vet-address.vue";
import vAddressPickerAws from "@/module/commons/vet-address-aws.vue";
import vSelect from "vue-select";
import CountryCode from "@/module/commons/countrycode.vue";
import ContactWarning from "@/components/commons/client-contact-field-warning";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Fuse from "fuse.js";
import { isObject, isUndefined, forEach } from "lodash";
import EXTENSIONS from "@/constants/extensions";
import CLIENT from "@/constants/clients";
import ClientContactDetailMixin from "@/mixins/client-contact-details";

export default {
    mixins: [ClientContactDetailMixin],
    components: {
        CountryCode,
        vSelect,
        vAddressPicker,
        VueSimpleSuggest,
        vAddressPickerAws,
        ContactWarning
    },
    props: {
        data: {
            type: Object
        },
        modalId: {
            type: String,
            required: true
        },
        // is new client
        isNew: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            resources: {},
            use_google_location: true,
            group_insert: false,
            reminder_options: [],
            clientOptions: [],
            chosenClient: "",
            datePickerOptions: {
                useCurrent: false,
                maxDate: new Date(),
                widgetParent: "#" + this.modalId
            },
            reminder_options_output: [],
            contacts: [],
            CLIENT
        };
    },
    computed: {
        formattedBirthdate: {
            get() {
                let format = this._getLuxonFormat();
                let date = this.data.birthdate;
                return this._reformatDateDisplay(date, "yyyy-MM-dd", format);
            },
            set(value) {
                let format = this._getLuxonFormat();
                this.data.birthdate = this._reformatDateDisplay(
                    value,
                    format,
                    "yyyy-MM-dd"
                );
            }
        },
        emailPlaceholder() {
            let mobileNumber = this.data.mobile || "";

            if (this.isMobileAppExtEnabled() && mobileNumber === "") {
                return "Email (required)";
            }

            return "Email (optional)";
        },
        mobilePhonePlaceholder() {
            let email = this.data.email || "";

            if (this.isMobileAppExtEnabled() && email === "") {
                return "Mobile Phone (required)";
            }

            return "Mobile Phone (optional)";
        },
        reminder_options_filter() {
            return this.reminder_options.filter(opt => {
                let isActive = opt.active === true;
                let isAlreadySelected = false;

                let selected = this.reminder_options_output.find(
                    o => o.id === opt.id
                );

                if (selected) {
                    isAlreadySelected = true; // prevent selected option to appear in dropdown
                }

                return isActive && !isAlreadySelected;
            });
        }
    },
    watch: {
        "data.mobile"(value) {
            this.reminderOption(
                this.REMINDER_TYPE.SMS,
                (this.data.mobile ||
                    this.checkContactTypeHasNextPrimary(
                        CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                        this.contacts
                    )) &&
                    (this._isExtensionEnabled("SMS") ||
                        this._isExtensionEnabled("2_WAY_MESSAGING"))
                    ? true
                    : false
            );
            this.reminderOption(
                this.REMINDER_TYPE.PHONE,
                value ||
                    this.data.home ||
                    this.data.work ||
                    this.checkContactTypeHasNextPrimary(
                        [
                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                            CLIENT.CONTACT_DETAIL_TYPES.HOME,
                            CLIENT.CONTACT_DETAIL_TYPES.WORK
                        ],
                        this.contacts
                    )
                    ? true
                    : false
            );
        },
        "data.home"(value) {
            this.reminderOption(
                this.REMINDER_TYPE.PHONE,
                value ||
                    this.data.mobile ||
                    this.data.work ||
                    this.checkContactTypeHasNextPrimary(
                        [
                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                            CLIENT.CONTACT_DETAIL_TYPES.HOME,
                            CLIENT.CONTACT_DETAIL_TYPES.WORK
                        ],
                        this.contacts
                    )
                    ? true
                    : false
            );
        },
        "data.work"(value) {
            this.reminderOption(
                this.REMINDER_TYPE.PHONE,
                value ||
                    this.data.mobile ||
                    this.data.home ||
                    this.checkContactTypeHasNextPrimary(
                        [
                            CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                            CLIENT.CONTACT_DETAIL_TYPES.HOME,
                            CLIENT.CONTACT_DETAIL_TYPES.WORK
                        ],
                        this.contacts
                    )
                    ? true
                    : false
            );
        },
        "data.address"(value) {
            this.reminderOption(this.REMINDER_TYPE.MAIL, value ? true : false);
        },
        "data.email"(value) {
            if (
                value ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.EMAIL,
                    this.contacts
                )
            ) {
                this.reminderOption(this.REMINDER_TYPE.EMAIL, true);
            } else {
                this.reminderOption(this.REMINDER_TYPE.EMAIL, false);
            }
        }
    },
    created() {
        this.$root.$on("bv::dropdown::shown", function (params) {});
        this.reminder_options = [
            { id: this.REMINDER_TYPE.EMAIL, label: "Email", active: false },
            { id: this.REMINDER_TYPE.MAIL, label: "Mail", active: false },
            { id: this.REMINDER_TYPE.PHONE, label: "Phone", active: false },
            {
                id: this.REMINDER_TYPE.SMS,
                label: "SMS (Text)",
                active: false
            }
        ];
    },
    mounted() {
        let refs = this.$refs;
        this.use_google_location =
            process.env.USE_GOOGLE_LOCATION === "true" ? true : false;
        this.formattedBirthdate = this.data.birthdate;
        /*
        Test case for reminder option
        - user add / remove from list
        - when field emptied / added
        - init - existing user reminder options
        - system default reminder options
        */
        this.reminderOption(
            this.REMINDER_TYPE.PHONE,
            this.data.mobile ||
                this.data.home ||
                this.data.work ||
                this.checkContactTypeHasNextPrimary(
                    [
                        CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                        CLIENT.CONTACT_DETAIL_TYPES.HOME,
                        CLIENT.CONTACT_DETAIL_TYPES.WORK
                    ],
                    this.contacts
                )
        );
        this.reminderOption(
            this.REMINDER_TYPE.SMS,
            (this.data.mobile ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.MOBILE,
                    this.contacts
                )) &&
                (this._isExtensionEnabled("SMS") ||
                    this._isExtensionEnabled("2_WAY_MESSAGING"))
        );
        this.reminderOption(
            this.REMINDER_TYPE.MAIL,
            this.data.address ? true : false
        );
        this.reminderOption(
            this.REMINDER_TYPE.EMAIL,
            this.data.email ||
                this.checkContactTypeHasNextPrimary(
                    CLIENT.CONTACT_DETAIL_TYPES.EMAIL,
                    this.contacts
                )
        );

        // user opted reminder options
        this.applyUserOptedInReminders();
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            if (modalId === "newClientModal" && refs.suggestField) {
                refs.suggestField.setText(this.data.firstname);
                refs.suggestField
                    .getSuggestions(this.data.firstname)
                    .then(() => {
                        refs.suggestField.input.focus();
                    });
            }
        });

        this.getContactDetails(this.data.id).then(contacts => {
            this.contacts = contacts;
        });
    },
    methods: {
        isMobileAppExtEnabled() {
            return this._isExtensionEnabled(
                EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
            );
        },
        selectSuggestedRecord(record) {
            const self = this;

            // apply record to all fields
            this.applyData({
                ...record
            });

            // reminders
            let selectedReminders = [];

            if (record.email && record.email !== "") {
                registerReminder(this.REMINDER_TYPE.EMAIL, selectedReminders);
            }

            if (record.address && record.address !== "") {
                registerReminder(this.REMINDER_TYPE.MAIL, selectedReminders);
            }

            if (record.mobile && record.mobile !== "") {
                registerReminder(this.REMINDER_TYPE.PHONE, selectedReminders);
            }

            this.reminder_options_output = selectedReminders;

            function registerReminder(typeId, selected = []) {
                const isExisted = selected.find(opt => opt.id === typeId);
                const option = self.reminder_options.find(
                    opt => opt.id === typeId
                );

                if (!isExisted) {
                    selected.push(option);
                }
            }
        },
        async searchClient(search) {
            if (!search || search.length < 3) {
                return;
            }

            let response = await this.$http.get(
                process.env.BARRAMUNDI + "actor/group-client-search",
                { params: { query: search } }
            );

            const results = response.data.response.resource;
            const fuse = new Fuse(results, {
                shouldSort: true,
                keys: ["label", "email", "mobile", "work", "home"]
            });

            return fuse.search(search);
        },
        applyData(record) {
            let data = record;
            if (data) {
                this.data.firstname = data.firstname;
                this.data.lastname = data.lastname;
                this.data.address = data.address;
                this.data.city = data.city;
                this.data.state = data.state;
                this.data.zipcode = data.zipcode;
                this.data.country = data.country;
                this.data.county = data.county;
                this.data.birthdate = data.birthdate;
                this.data.email = data.email;
                this.data.driver_license = data.driver_license;
                this.data.home = data.home;
                this.data.home_country_code = data.home_country_code;
                this.data.mobile = data.mobile;
                this.data.mobile_country_code = data.mobile_country_code;
                this.data.work = data.work;
                this.data.work_country_code = data.work_country_code;
                this.data.fax = data.fax;
                this.data.fax_country_code = data.fax_country_code;
                this.data.id = data.id;
                this.data.group_insert = true;
            }
        },
        actorSelected(actor) {
            let self = this;
            forEach(self.data, (element, key) => {
                if (key != "firstname") {
                    self.data[key] = null;
                }
            });
            forEach(actor, (element, key) => {
                if (key != "firstname") {
                    self.data[key] = element;
                }
            });
            this.$forceUpdate();
        },
        reminderOption(id, active) {
            let options = [...this.reminder_options];
            let option = options.find(opt => opt.id === id);

            // if option not found, skip.
            if (!option) {
                return;
            }

            // update options
            option.active = active;
            this.reminder_options = options;

            // auto select if new client.
            // existing client will use current saved values (manually select)
            if (active && this.isNew) {
                let outputs = this.reminder_options_output;
                let existed = outputs.find(o => o.id === id);

                if (!existed) {
                    this.reminder_options_output.push(option);
                }
            }
            // remove from selected if active=false
            else if (!active) {
                this.reminder_options_output = this.reminder_options_output.filter(
                    opt => opt.id !== id
                );
            }
        },
        /**
         * update parent's data (ie client data) to be used for next step.
         * convert from array of object to array of string.
         * eg [{ id:1 }, { id:4 }] => ['1', '4'].
         * NOTE: To be called from parent. Do not remove.
         */
        remindersToString() {
            let arrStr = [];
            for (let selected of this.reminder_options_output) {
                arrStr.push(selected.id.toString()); // eg: 3 => '3'
            }
            return arrStr;
        },
        applyUserOptedInReminders() {
            let reminders = this.data.reminder_options || [];
            let allOptions = this.reminder_options; // all options without filter (ie active + inactive)
            let results = [];

            for (let id of reminders) {
                let nid = Number(id); // convert to number, as id is stored in Number

                if (isNaN(nid)) {
                    continue;
                }

                let selectedOpt = allOptions.find(opt => opt.id === nid);
                if (selectedOpt) {
                    results.push(selectedOpt);
                }
            }

            this.reminder_options_output = results;
        },
        addressPicked(address) {
            let self = this;
            if (isObject(address) && !isUndefined(address.address)) {
                self.data.address = address.address;
                self.data.zipcode = address.zipcode;
                self.data.city = address.city;
                self.data.county = address.county;
                self.data.state = address.state;
                self.data.country = address.country;
            }
        }
    }
};
</script>

<style lang="scss">
#newClientModal {
    .suggest-item-vetter {
        .hover,
        .selected {
            background-color: #0097cf !important;
        }
    }

    .vue-simple-suggest.designed .suggestions {
        overflow: scroll;
        max-height: 350px;
    }
}
</style>
